import { SpecialQualifications } from "@clipboard-health/contract-worker-app-bff";
import { useWorkerQualifications } from "@src/appV2/Worker/useWorkerQualifications";

import { useWorkerCustomToBaseQualificationNameMap } from "../useWorkerCustomToBaseQualificationNameMap";
import { substituteQualification } from "../utils";

/**
 * Resolves the display labels for a list of qualifications.
 * If a qualification is not found, it returns the original qualification name.
 */
export function useGetQualificationDisplayLabels(qualificationNames: string[]) {
  const customToBaseQualificationNameMap = useWorkerCustomToBaseQualificationNameMap();

  const { data: workerQualifications, ...queryResult } = useWorkerQualifications();
  const qualificationNameToDisplayLabelMap = new Map<string, string>();

  const displayLabels = qualificationNames.map((qualificationName) => {
    // We intentionally hide custom qualifications from workers. If we come across a custom qualification,
    // we need to substitute it with the base qualification name.
    const baseQualificationName =
      customToBaseQualificationNameMap.get(qualificationName) ?? qualificationName;

    const substitutedQualificationName = substituteQualification(
      baseQualificationName,
      workerQualifications?.map((qualification) => qualification.attributes.name) ?? []
    );

    // CNA's are able to view CAREGIVER shifts, but might not have it as a shoppable qualification
    const displayLabel =
      substitutedQualificationName === SpecialQualifications.CAREGIVER
        ? "Caregiver"
        : (workerQualifications?.find((q) => q.attributes.name === substitutedQualificationName)
            ?.attributes.displayLabel ?? substitutedQualificationName);

    qualificationNameToDisplayLabelMap.set(qualificationName, displayLabel);

    return displayLabel;
  });

  return {
    data: displayLabels,
    qualificationNameToDisplayLabelMap,
    ...queryResult,
  };
}
